type SignupDevice = {
  userAgent: string;
  platform?: string;
  maxTouchPoints?: number;
  userAgentData?: { mobile?: boolean };
};

export function merchantSignupDestination(device: SignupDevice, origin = 'https://beaw.club'): string {
  const mobile = device.userAgentData?.mobile === true ||
    /Android|iPhone|iPad|iPod|Mobile/i.test(device.userAgent) ||
    // iPad Safari can identify itself as a desktop Mac.
    (/Mac/i.test(`${device.platform || ''} ${device.userAgent}`) && (device.maxTouchPoints || 0) > 1);
  const current = new URL(origin);
  if (current.port === '3889') {
    if (mobile) current.port = '2888';
    return new URL(mobile ? '/creator/merchant/wallet' : '/for-merchant/manage', current.origin).href;
  }
  return mobile ? 'https://m.beaw.club/creator/merchant/wallet' : 'https://beaw.club/for-merchant/manage';
}
